module.exports = __webpack_public_path__ + "img/bibf.598d591f.png";